"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("@almservices-cl/clock");
class CustomerAdapter {
    constructor(dateTimeBridge, systemDateTimeProvider, dateTimeModifier, dateTimeProvider) {
        this.adapt = (customer, timeZone) => {
            return {
                id: customer.id,
                galleryId: customer.galleryId,
                firstName: customer.firstName,
                lastName: customer.lastName,
                address: customer.address,
                phoneNumber: customer.phoneNumber,
                email: customer.email,
                isIntakeDone: customer.isIntakeDone,
                isNew: customer.isNew,
                isProlonger: customer.isProlonger,
                hasUpgraded: customer.hasUpgraded,
                hasUpgradedToCoaching: customer.hasUpgradedToCoaching,
                trainingLocation: customer.trainingLocation,
                code: customer.code,
                method: customer.method,
                notifications: customer.notifications,
                plan: customer.plan,
                birthDate: customer.birthDate
                    ? this.dateTimeBridge.userDate(customer.birthDate)
                    : null,
                eventsNotification: {
                    daysToBirthday: customer.birthDate
                        ? this.dateTimeModifier.calcDaysToEvent(customer.birthDate, this.systemDateTimeProvider.currentDate())
                        : null,
                    daysToPlanEnd: this.dateTimeModifier.calcDaysToEvent(customer.subscriptionPeriod.endDate, this.systemDateTimeProvider.currentDate()),
                    daysToSubscriptionsEnd: (0, clock_1.daysDifference)(this.systemDateTimeProvider.currentDate(), customer.period.dateOfPeriodEnd),
                    isNew: customer.isNew,
                    isProlonger: customer.isProlonger,
                    hasRejoined: customer.hasRejoined,
                    hasNewCoach: customer.hasNewCoach,
                    hasUpgraded: customer.hasUpgraded,
                },
                subscription: this.fixSubscriptionDateFormat(customer.subscriptionPeriod),
                period: {
                    ...customer.period,
                    dateOfPeriodStart: this.dateTimeBridge.userDate(customer.period.dateOfPeriodStart),
                    dateOfPeriodEnd: this.dateTimeBridge.userDate(customer.period.dateOfPeriodEnd),
                },
                lastActiveFromNow: customer.lastActive
                    ? this.dateTimeProvider.fromNow(customer.lastActive, timeZone)
                    : null,
                lastActive: customer.lastActive
                    ? this.dateTimeBridge.userDateTime(customer.lastActive)
                    : null,
                responseDeadlineHours: customer.responseDeadLine
                    ? this.dateTimeModifier.diffHoursFormatted(this.systemDateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()), {
                        date: customer.responseDeadLine,
                        format: clock_1.FORMAT_RAW,
                    })
                    : null,
                absoluteDay: customer.absoluteDay,
            };
        };
        this.fixSubscriptionDateFormat = (sub) => {
            return {
                ...sub,
                startDate: this.dateTimeBridge.userDate(sub.startDate),
                endDate: this.dateTimeBridge.userDate(sub.endDate),
            };
        };
        this.dateTimeBridge = dateTimeBridge;
        this.systemDateTimeProvider = systemDateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeProvider = dateTimeProvider;
    }
}
exports.default = CustomerAdapter;
//# sourceMappingURL=CustomerAdapter.js.map